import { select, put, call, takeLatest } from "redux-saga/effects";
import CustomerInformationApi from "../api/ServiceApi";
import * as types from "./customerInformationActionTypes";
import {
    loadCustomerInformationSuccess,
    loadCustomerInformationFailed
    } from "./customerInformationActions";

export const getOidc = (state) => state.oidc;

function* fetchCustomerInformation() {
    try {
        let oidc = yield select(getOidc);
        const response = yield call(CustomerInformationApi.getCustomerInformation, oidc.user);
        yield put(loadCustomerInformationSuccess(response));
    } catch (e) {
        yield put(loadCustomerInformationFailed(e.message));
    }
}

export function* loadCustomerInformationSaga() {
    yield takeLatest(types.LOAD_CUSTOMER_INFORMATION, fetchCustomerInformation);
}


// WEBPACK FOOTER //
// ./src/customer-information/sagas.js